export const headerNavData = [
  //  { title: "Pricing", path: "/pricing" },
  {dropdown: 'cylerian', title: 'Features', path: '/platform'},
  {dropdown: 'services', title: 'Services', path: '/services'},
  {dropdown: 'partners',title: 'Partners', path: '/partners'},
  {dropdown: 'company', title: 'Company', path: '/company'},
  /*
  {title: 'Blog', path: '/blog'},
  {title: 'Security', path: '/security'},
  {title: 'Observability', path: '/observability'},
  {title: 'Operations', path: '/operations'}
  */
];


export const dropdownNavData = [
  {title: 'Overwiew', path: '/platform'},
  {title: 'Security', path: '/security'},
  {title: 'Observability', path: '/observability'},
  {title: 'Operations', path: '/operations'}
];

export const footerNavData = [
  {title: 'Contact', path: '/contact'},
  {title: 'Events', path: '/events'},
  {title: 'Resources', path: '/resources'},
  {title: 'Legal', path: '/legal'},
  {title: 'Blog', path: '/blog'},
  {title: 'News', path: '/news'}
  //  { title: "Pricing", path: "/pricing" },
];

export const footerLinksData = [
  {title: 'Privacy Policy', path: '/privacy'},
  {title: 'Terms', path: '/terms'}
];

